// Every React Query cache key the app uses, in one place. A key is built here and nowhere else, so two
// parts of the app that mean the same data can't drift apart by spelling it differently, and "which caches
// does this change touch?" can be answered by searching for one name.
//
// Keys with optional trailing parts double as prefixes: queryKeys.taskSearch(boardId) matches every search
// for that board, which is what invalidating after a change wants.
export const queryKeys = {
    chat: (boardId: string) => ['boardChat', boardId] as const,
    boards: () => ['boards'] as const,
    board: (boardId: string) => ['board', boardId] as const,
    members: (boardId: string) => ['members', boardId] as const,
    boardInvitations: (boardId: string) => ['boardInvitations', boardId] as const,
    kioskPhotos: (boardId: string) => ['kioskPhotos', boardId] as const,
    calendarFeeds: (boardId: string) => ['calendarFeeds', boardId] as const,
    user: () => ['user'] as const,
    notifications: () => ['notifications'] as const,
    dashboard: (days: number) => ['dashboard', days] as const,
    emailNotifications: () => ['emailNotifications'] as const,

    // The board's tasks, not archived: the one list every view (board, week, kiosk) draws from.
    tasks: (boardId: string) => ['tasks', boardId] as const,
    archivedTasks: (boardId: string) => ['archivedTasks', boardId] as const,

    taskSearch: (boardId: string, text?: string) =>
        (text === undefined ? ['taskSearch', boardId] : ['taskSearch', boardId, text]) as readonly unknown[],
    boardStats: (boardId: string, days?: number, timeZone?: string) =>
        (days === undefined ? ['boardStats', boardId] : ['boardStats', boardId, days, timeZone]) as readonly unknown[],
};
